module.exports = __webpack_public_path__ + "img/ForkLift.2ae196ba.png";